import { render, staticRenderFns } from "./SubscriptionView.vue?vue&type=template&id=c536d5e6"
import script from "./SubscriptionView.vue?vue&type=script&lang=ts"
export * from "./SubscriptionView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports